// Counter.js
import React, { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const NumberCounter = ({
  targetNumber = 1500,
  startFrom = 0,
  // duration = 1,
  customCss,
  addPlus,
}) => {
  const scope = useRef(null);

  useGSAP(() => {
    const obj = { val: startFrom };
    // const duration = Math.max(1, targetNumber / 100);

    gsap.to(obj, {
      val: targetNumber,
      duration: 1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: scope.current,
        start: "top 80%",
        end: "top 60%",
        // toggleActions: "play none none none",
        toggleActions: "play none reset reset",
        // markers: true,
      },
      onUpdate: () => {
        const el = scope.current;
        el.textContent = `${Math.floor(obj.val).toLocaleString()}${
          addPlus ? "+" : ""
        }`;
      },
    });
  }, scope);

  return (
    <h2 ref={scope} className={customCss}>
      {0}
    </h2>
  );
};

export default NumberCounter;
